import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from "vue";
import SvgColumns from "@/assets/icons/columns.svg";
import SvgReset from "@/assets/icons/reload.svg";
import SvgClose from "@/assets/icons/cancel.svg";
import BaseButtonV2 from "@/components-UI/buttons/BaseButtonV2.vue";
import ColumnsList from "@/components-UI/table/columns/ColumnsList.vue";
import { IColumnsGroup } from "@/utils/ColumnsCreator";
import { useColumnsStore } from "@/store_v3/ColumnsStore";
import { useRoute } from "vue-router/composables";
import { updateQueryString } from "@/utils/updateQueryString";
import { useWindowResize } from "@/utils/useWindowSize";
import { storeToRefs } from "pinia";
import isEqual from "lodash-es/isEqual";

interface Props {
    width?: number | string;
    columns: IColumnsGroup[];
    defaultColumns: string[];
    responsive?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TableColumns',
  props: {
    width: { default: 350 },
    columns: { default: () => ([]) },
    defaultColumns: { default: () => ([]) },
    responsive: { type: Boolean, default: false }
  },
  setup(__props: any, { expose }) {

const props = __props as { width: number | string, columns: IColumnsGroup[], defaultColumns: string[], responsive: boolean }


const route = useRoute();
const { width } = useWindowResize();
const isMobile = computed(() => width.value <= 768);

const getColumnsWidth = computed(() => {
    if (typeof props.width === 'string') {
        return { width: props.width };
    }
    return props.responsive
        ? `width: min(${props.width}px, 100vw)`
        : `width: ${props.width}px`;
});

const isShowColumns = ref(false);

const showColumns = () => {
    isShowColumns.value = true;
};

const closeColumns = () => {
    isShowColumns.value = false;
};

const clickOnOverlay = (e: PointerEvent) => {
    const { target } = e as PointerEvent & { target: HTMLElement };
    if (target.classList.contains('table-columns__overlay')) closeColumns();
};

const { selected } = storeToRefs(useColumnsStore());
const { updateAllSelectedColumns } = useColumnsStore();

onMounted(() => {
    const queryCols = route.query.columns as string[] | undefined;
    const availableCols = props.columns.flatMap(group => group.items.map(item => item.value));
    
    if (queryCols && Array.isArray(queryCols) && queryCols.length > 0) {
        const validCols = queryCols.filter(col => availableCols.includes(col));
        if (validCols.length !== queryCols.length) {
            updateAllSelectedColumns(validCols.length > 0 ? validCols : props.defaultColumns);
            updateColumns(validCols.length > 0 ? validCols : props.defaultColumns);
        } else {
            updateColumns();
        }
    } else {
        updateColumns();
        if (!route.query.columns || route.query.columns.length === 0) {
            resetColumns();
        }
    }
});

watch(() => route.query.columns, () => {
    const isChanged = !isEqual(route.query.columns, selected.value);
    if (isChanged) {
        updateColumns();
    }
});

const applyColumns = () => {
    updateColumns();
    closeColumns();
};

const resetColumns = () => {
    updateAllSelectedColumns(props.defaultColumns);
    updateColumns(props.defaultColumns);
};

const updateColumns = (columns: string[] = selected.value) => {
    const query = { ...route.query, columns };
    updateQueryString(query);
};

expose({
    resetColumns,
});

return { __sfc: true,props, route, width, isMobile, getColumnsWidth, isShowColumns, showColumns, closeColumns, clickOnOverlay, selected, updateAllSelectedColumns, applyColumns, resetColumns, updateColumns, SvgColumns, SvgReset, SvgClose, BaseButtonV2, ColumnsList }
}

})